import { render, staticRenderFns } from "./ProjectCreatePage.vue?vue&type=template&id=335c4934"
import script from "./ProjectCreatePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectCreatePage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports